ProduitValidator.$inject = ['validator'];

export default function ProduitValidator(validator) {
    const instance = new validator();
    return instance;
}
